
<div class="content">
    <markdown [src]="markdownPath"></markdown>
</div>
